module.exports = __webpack_public_path__ + "static/media/schmodel-logo-gold.22a63367.png";